import React, { Component } from 'react';
import { FadeLoader } from 'react-spinners';
import ReactPaginate from 'react-paginate';

const TablaCliente = (props) => {
  if (props.data.length) {
    return props.data.map(cliente => (
      <tr key={cliente.codigo} onClick={() => props.saveClient(cliente, props.tipoCliente, props.indice)}>
        <td>{cliente.codigo}</td>
        <td>{cliente.nombre}</td>
        <td>{cliente.ruc}</td>
        <td>{cliente.dni}</td>
      </tr>
    ));
  }
  return <tr><td className='no-before' colSpan={4}>No hay resultados</td></tr>;
};

class EditarCliente extends Component {
  constructor(props) {
    super(props);

    this.state = {
      option: 'cadena',
      clienteInput: '',
      clientes: null,
      showTable: false,
    };
  }

  onChangeValue = e => this.setState({ [e.target.name]: e.target.value })

  search = () => {
    const { option, clienteInput } = this.state;
    if (clienteInput.trim()) {
      this.setState({ clientes: null, showTable: true });
      this.props.clearClientes();
      this.props.fetchClientes(option, clienteInput)
        .then(() => this.setState({ clientes: Object.assign({}, this.props.clientes) }));
    }
  }

  paginateClient = ({ selected }) => {
    const { option, clienteInput } = this.state;
    this.props.fetchClientes(option, clienteInput, selected + 1)
      .then(() => this.setState({ clientes: Object.assign({}, this.props.clientes) }));
  }

  render() {
    const { option, clienteInput, showTable } = this.state;

    if (!this.props.isOpen) return null;

    return (
      <div className='tableSearch'>
        <div className='row'>
          <div className='col-md-6 mb-3 mt-2'>
            <div className='fSearch'>
              <div className='fSearch-filter form-control'>
                <select value={option} name='option' onChange={this.onChangeValue}>
                  <option value='cadena'>Cliente</option>
                  <option value='dni'>DNI</option>
                  <option value='ruc'>RUC</option>
                </select>
              </div>
              <input
                className='fSearch-search form-control'
                value={clienteInput}
                name='clienteInput'
                onChange={this.onChangeValue}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    this.search();
                  }
                }}
              />
              <button className='btn btn-dark fSearch-go' onClick={this.search}>
                <i className='ion-android-arrow-forward' />
              </button>
            </div>
          </div>
        </div>
        <div className={showTable ? 'hidden-xs' : 'hidden'}>
          <div className='tableWrapper'>
            <table className='table table-hover'>
              <thead className='table-head'>
                <tr>
                  <th>Código</th>
                  <th>Nombre</th>
                  <th>RUC</th>
                  <th>DNI</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.clientes
                   ?
                     <TablaCliente
                       data={this.state.clientes.data}
                       saveClient={this.props.saveClient}
                       tipoCliente={this.props.tipoCliente}
                       indice={this.props.indice}
                     />
                   : <tr><td className='no-before' colSpan={5}><FadeLoader color={'#F8A14A'} loading /></td></tr>
                }
              </tbody>
            </table>
          </div>
          {
            this.state.clientes &&
            <div className={this.state.clientes.numerodePaginas > 1 ? 'paginationWrapper' : 'hidden'}>
              <div className='row' style={{ marginTop: '20px' }}>
                <div className='col-sm-6 pull-right'>
                  <ReactPaginate
                    pageCount={this.state.clientes.numerodePaginas}
                    onPageChange={this.paginateClient}
                    previousLabel='<<'
                    nextLabel='>>'
                    containerClassName='pagination pull-right'
                    pageClassName='pagination-item'
                    activeClassName='pagination-item--active'
                    pageLinkClassName='btn-clean pagination-item-btn'
                    breakClassName='break pagination-item'
                  />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default EditarCliente;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Proformas/AsociarPedidos/EditarCliente.js